export default "__VITE_ASSET__97bd87e6__"